import { type AvailableMapType, type ScheduleType } from 'types/Schema';
import { type TableMapType, type TableType } from 'types/Table';

const getAvailableMapForDate = (
  schedule: ScheduleType[],
  date: string
): AvailableMapType | undefined => {
  return schedule?.find((item: ScheduleType) => item.date === date)
    ?.available_map;
};

export const getTimesForDate = (
  schedule: ScheduleType[],
  date: string
): string[] => {
  const availableMap = getAvailableMapForDate(schedule, date);
  if (availableMap === null || availableMap === undefined) return [];
  return Object.keys(availableMap).sort((a, b) => (a > b ? 1 : -1));
};

export const getPeopleCountsForTime = (
  schedule: ScheduleType[],
  date: string,
  time: string
): number[] => {
  const availableMap = getAvailableMapForDate(schedule, date);
  if (availableMap === null || availableMap === undefined) return [];
  const tableTime = Object.keys(availableMap).find((item) => item === time);
  if (tableTime === null || tableTime === undefined) return [];
  const timeMap = availableMap[tableTime];
  const tableList = timeMap?.tables;
  if (!tableList || tableList.length === 0) {
    return [];
  }
  const maxCapacity = tableList.reduce(
    (max: number, item: TableType) =>
      item.capacity > max ? item.capacity : max,
    tableList[0].capacity
  );
  return Array.from({ length: maxCapacity }, (_, i) => i + 1);
};

export const getTablesForPeople = (
  schedule: ScheduleType[],
  date: string,
  time: string,
  people: number
): TableType[] => {
  const availableMap = getAvailableMapForDate(schedule, date);
  if (availableMap === null || availableMap === undefined) return [];
  const tableTime = Object.keys(availableMap).find((item) => item === time);
  if (tableTime === null || tableTime === undefined) return [];
  const timeMap = availableMap[tableTime];
  const tableList = timeMap?.tables;
  if (tableList === null || tableList === undefined) return [];
  const selectableTableList = tableList.filter(
    (item: TableType) => item.capacity >= people
  );
  return selectableTableList;
};

export const getTableMapForPeople = (
  schedule: ScheduleType[],
  date: string,
  time: string,
  people: number
): TableMapType[] => {
  const availableMap = getAvailableMapForDate(schedule, date);
  if (availableMap === null || availableMap === undefined) return [];
  const tableTime = Object.keys(availableMap).find((item) => item === time);
  if (tableTime === null || tableTime === undefined) return [];
  const timeMap = availableMap[tableTime];
  const tableMapList = timeMap?.table_map;
  if (
    tableMapList === null ||
    tableMapList === undefined ||
    tableMapList.length === 0
  ) {
    return [];
  }
  return tableMapList.map((item: TableMapType) => {
    return {
      ...item,
      table_list: [
        ...item.table_list.filter(
          (table: TableType) => table.capacity >= people
        ),
      ],
    } as TableMapType;
  });
};
